import { api } from "./api";

export interface Invitation {
  _id: string;
  storeId: string;
  email: string;
  role: "co_admin";
  status: "pending" | "accepted" | "expired" | "cancelled";
  invitedBy?: {
    _id: string;
    name: string;
    email: string;
  };
  token: string;
  expiresAt: string;
  acceptedAt?: string;
  cancelledAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface InvitationsListResponse {
  invitations: Invitation[];
}

export interface InvitationByTokenResponse {
  invitation: {
    _id: string;
    email: string;
    storeName: string;
    expiresAt: string;
  };
}

export interface AcceptInvitationRequest {
  token: string;
  name: string;
  username: string;
  password: string;
}

export const invitationApi = {
  async getInvitations(): Promise<InvitationsListResponse> {
    const response = await api.get("/invitations");
    return response.data;
  },

  async createInvitation(email: string): Promise<Invitation> {
    const response = await api.post("/invitations", { email });
    return response.data;
  },

  async resendInvitation(id: string): Promise<Invitation> {
    const response = await api.post(`/invitations/${id}/resend`);
    return response.data;
  },

  async cancelInvitation(id: string): Promise<void> {
    await api.delete(`/invitations/${id}`);
  },

  async getInvitationByToken(token: string): Promise<InvitationByTokenResponse> {
    const response = await api.get(`/invitations/accept?token=${encodeURIComponent(token)}`);
    return response.data;
  },

  async acceptInvitation(data: AcceptInvitationRequest): Promise<{ message: string; user: any }> {
    const response = await api.post("/invitations/accept", data);
    return response.data;
  },
};
